import { Head } from '@inertiajs/react';
import { Button } from '@/components/ui/button';

const Correr = () => {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <Head title="correremovia" />
      <main className="relative min-h-screen overflow-hidden px-6 py-10">
        <div className="absolute inset-0 bg-linear-to-tr from-muted/40 via-background to-background" aria-hidden="true" />
        <div
          className="absolute left-[-5%] bottom-[-10%] h-96 w-96 rounded-full bg-primary/25 blur-3xl"
          aria-hidden="true"
        />
        <div className="relative mx-auto flex min-h-screen max-w-3xl flex-col justify-center gap-6">
          <div className="flex flex-col gap-2">
            <p className="text-muted-foreground">Checkpoint 01</p>
            <h1>correremovia</h1>
          </div>
          <p className="text-muted-foreground">Si corre via dall&apos;ansia, non da se.</p>
          <div className="flex max-w-lg flex-col gap-3">
            <div className="h-2 rounded-full bg-muted">
              <div className="correr-bar h-2 rounded-full bg-primary" aria-hidden="true" />
            </div>
            <p className="text-muted-foreground">Ritmo giusto, direzione giusta.</p>
          </div>
          <Button asChild className="self-start">
            <a href="https://www.emovia.com">Scopri Emovia</a>
          </Button>
          <div className="rounded-full border border-border px-4 py-1">
            <p className="text-muted-foreground">Progressivo, non frenetico</p>
          </div>
        </div>
      </main>
      <style>{`
        .correr-bar {
          animation: correr-bar 2.4s ease-in-out infinite;
          width: 38%;
        }
        @keyframes correr-bar {
          0% { width: 28%; }
          50% { width: 78%; }
          100% { width: 28%; }
        }
        @media (prefers-reduced-motion: reduce) {
          .correr-bar { animation: none; width: 60%; }
        }
      `}</style>
    </div>
  );
};

export default Correr;
